/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { generatePath } from "react-router"
// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { 運行管理メニューコード } from "../../../constant/menuCode"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import DateInput from "../../../components/InputWrapper/DateInput"
import {
  TTenkoDetailInfoGetRes,
  TenkoResultListGetReq,
} from "../../../service/truckcontrol/tenko/TTenko"
import TenkoService from "../../../service/truckcontrol/tenko/tenkoService"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import { RootState } from "../../../globalStore/rootreducer"
import dayjs from "dayjs"
import dateUtil from "../../../ts/util/dateUtil"
import {
  tenkoResultListExcelFormat,
  tenkoResultListPdfFormat,
} from "../../../ts/util/exportUtil"
import TextInput from "../../../components/InputWrapper/TextInput"
import { FunctionContext } from "../../../components/Context"
import CheckInput from "../../../components/InputWrapper/CheckInput"

/**
 * 点呼結果一覧
 * @returns
 */
const TenkoResultList = () => {
  const history = useHistory()
  const location = useLocation()
  const { eigyobiStr: 当日 } = useSelector((state: RootState) => state.date)
  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )

  let gridId = "TenkoResultList_GridId"

  //検索条件保持用
  const [preSearchCondition, setPreSearchCondition] =
    useState<TenkoResultListGetReq>({} as TenkoResultListGetReq)

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TenkoResultListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TenkoResultListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    // 検索ボタン押下時の検索条件を保持
    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new TenkoService().getResultList(currentSearchCondition)
      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態を解除
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TenkoResultListGetReq = queryString.parse(location.search)
    set点呼日From(query.点呼日From)
    set点呼日To(query.点呼日To)
    set部所コード(query.部所コード ?? userInfo.部所コード ?? "")
    set社員コード(query.社員コード)
    set乗務員名(query.乗務員名)
    set点呼アラート有無(query.点呼アラート有無 ?? 0)

    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TenkoResultListGetReq => {
    return {
      点呼日From: dateUtil.format(点呼日From) ?? "",
      点呼日To: dateUtil.format(点呼日To) ?? "",
      部所コード: 部所コード ?? undefined,
      社員コード: 社員コード ?? undefined,
      乗務員名: 乗務員名 ?? undefined,
      点呼アラート有無: 点呼アラート有無 === 1 ? 1 : 0,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TenkoResultListGetReq
  ) => {
    return {
      点呼日From: wjCore.isNullOrWhiteSpace(searchCondition.点呼日From ?? "")
        ? ""
        : searchCondition.点呼日From,
      点呼日To: wjCore.isNullOrWhiteSpace(searchCondition.点呼日To ?? "")
        ? ""
        : searchCondition.点呼日To,
      部所コード: wjCore.isNullOrWhiteSpace(searchCondition.部所コード ?? "")
        ? ""
        : searchCondition.部所コード,
      社員コード: wjCore.isNullOrWhiteSpace(searchCondition.社員コード ?? "")
        ? ""
        : searchCondition.社員コード,
      乗務員名: wjCore.isNullOrWhiteSpace(searchCondition.乗務員名 ?? "")
        ? ""
        : searchCondition.乗務員名,
      点呼アラート有無: searchCondition.点呼アラート有無 === 1,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set点呼日From(Date)
    set点呼日To(Date)
    set部所コード(userInfo.部所コード ?? "")
    set社員コード("")
    set乗務員名("")
    set点呼アラート有無(0)
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(15)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [点呼日From, set点呼日From] = useState<string | null | undefined>(当日)
  const [点呼日To, set点呼日To] = useState<string | null | undefined>(当日)
  const [部所コード, set部所コード] = useState<string | null>()
  const [社員コード, set社員コード] = useState<string>()
  const [乗務員名, set乗務員名] = useState<string>()
  const [点呼アラート有無, set点呼アラート有無] = useState<number>(0)

  //#region [comboboxState]
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>() //#endregion

  const [comboBoxDataInitialized, setComboBoxDataInitialized] = useState(false)

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)

      setComboBoxDataInitialized(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboBoxDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        set部所コード(userInfo.部所コード)
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboBoxDataInitialized])

  useEffect(() => {
    document.title = `点呼結果一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">点呼結果一覧</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <FunctionContext.Provider
          value={() => {
            search(preSearchCondition)
          }}>
          <Row>
            <Col>
              {/* 検索条件カード */}
              <Card className="w-100rem">
                {/* CardHeaderをアコーディオン化 */}
                <Card.Header
                  onClick={() => setAccordionController(!accordionController)}
                  aria-controls="collapse-search-card-body"
                  aria-expanded={accordionController}>
                  <FontAwesomeIcon
                    icon={accordionController ? faChevronDown : faChevronUp}
                    size={"1x"}
                  />
                  検索条件
                </Card.Header>
                <Collapse in={accordionController}>
                  <Card.Body>
                    <Form>
                      <Container fluid className="contents-search-main">
                        <Row>
                          <Col>
                            <div className="search-condition-table">
                              <div className="search-condition-row">
                                <div className="w-13rem">
                                  <DateInput
                                    id="点呼日from"
                                    placeholder="点呼日From"
                                    isRequired={true}
                                    has1DayButton={true}
                                    value={点呼日From}
                                    defaultValue={当日}
                                    setValue={(v) => {
                                      set点呼日From(v)
                                    }}></DateInput>
                                </div>
                                <div className="w-13rem">
                                  <DateInput
                                    id="点呼日To"
                                    placeholder="点呼日To"
                                    value={点呼日To}
                                    isRequired={true}
                                    has1DayButton={true}
                                    defaultValue={当日}
                                    setValue={(v) => {
                                      set点呼日To(v)
                                    }}></DateInput>
                                </div>
                                <div className="w-15rem">
                                  <ComboBox.Busyo
                                    placeholder="部所"
                                    isRequired={true}
                                    itemsSource={部所ItemSource}
                                    isLoadEnded={部所IsLoadEnded}
                                    setIsLoadEnded={set部所IsLoadEnded}
                                    listFilter={(d) => d.運行部所フラグ === 1}
                                    selectedValue={部所コード}
                                    setSelectedValue={set部所コード}
                                    ComboBox={部所ComboBox}
                                    setComboBox={
                                      set部所ComboBox
                                    }></ComboBox.Busyo>
                                </div>
                                <div className="input-group">
                                  <TextInput
                                    style={{ width: "6rem" }}
                                    id="社員コード"
                                    name="社員コード"
                                    value={社員コード}
                                    setValue={set社員コード}
                                    maxLength={4}
                                    placeholder="社員CD"
                                  />
                                  <TextInput
                                    id="乗務員名"
                                    name="乗務員名"
                                    value={乗務員名}
                                    setValue={set乗務員名}
                                    maxLength={100}
                                    placeholder="乗務員名"
                                  />
                                </div>
                                <span className={"align-middle"}>
                                  <CheckInput
                                    id="廃止"
                                    type={"switch"}
                                    label={"アラートが発生した点呼のみ表示する"}
                                    setValue={(v) => set点呼アラート有無(v)}
                                    value={点呼アラート有無}
                                  />
                                </span>
                              </div>
                            </div>
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </Col>
                        </Row>
                      </Container>
                    </Form>
                  </Card.Body>
                </Collapse>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              {/* 検索結果カード */}
              <Card>
                <Spinner searching={isSearching}></Spinner>
                <Card.Body>
                  <Row>
                    <Col>
                      {/* 検索条件表示コンポーネント */}
                      <DisplaySearchConditionLabel
                        displaySearchCondition={displaySearchCondition}
                      />
                    </Col>
                  </Row>
                  <FlexGridOuter
                    flexGrid={flexGrid}
                    setFlexGrid={setFlexGrid}
                    gridConstantProperties={
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                    }
                    gridData={gridData}
                    setGridData={setGridData}
                    pageNumber={pageNumber}
                    searchConditionClear={searchConditionClear}
                    gridId={gridId}
                    isRestoreSearching={isRestoreSearching}
                    setIsRestoreSearching={setIsRestoreSearching}
                    gridInitialized={gridInitialized}
                    setGridInitialized={setGridInitialized}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    gridInitializedHandler={gridInitializedHandler}
                    excelFormatItem={tenkoResultListExcelFormat}
                    pdfFormatItem={tenkoResultListPdfFormat}
                    headerComponent={
                      <>
                        {/* PCの場合一覧から遷移する */}
                        {/* <Link
                        to={
                          util.getMenuPath(運行管理メニューコード.点呼記録)[0]
                        }
                        onClick={() =>
                          gridPageHelper.savePageConditionData(
                            location.pathname
                          )
                        }>
                        <Button disabled={isSearching}>
                          <FontAwesomeIcon icon={faPlusSquare} />
                          点呼記録
                        </Button>
                      </Link> */}
                      </>
                    }>
                    <wjrGrid.FlexGridColumn
                      header=" "
                      allowMerging="true"
                      align="center"
                      width={90}
                      selectable={false}
                      isReadOnly>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTenkoDetailInfoGetRes>
                        ) => {
                          // 点呼記録
                          const url = util.getMenuPath(
                            運行管理メニューコード.点呼記録
                          )[1]

                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              onClick={() => {
                                // 画面全体のスクロール位置の保存
                                gridPageHelper.savePageConditionData(
                                  location.pathname
                                )

                                //受け渡すパラメータ
                                history.push(
                                  generatePath(url, {
                                    zyomuin_id: context.item.乗務員ID,
                                    date: context.item.点呼日,
                                    tenko_kbn: context.item.点呼区分コード,
                                    tenko_count: context.item.点呼回数,
                                  }),
                                  {
                                    ...context.item,
                                  } as TTenkoDetailInfoGetRes
                                )
                              }}>
                              点呼記録
                            </Button>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="乗務員社員コード"
                      width={90}
                      header="社員番号"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="乗務員社員名"
                      width={130}
                      header="乗務員"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="車番"
                      width={85}
                      header="車番"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="トレーラ車番"
                      width={85}
                      header="トレーラ"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="点呼日"
                      width={80}
                      multiLine={true}
                      header="点呼日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTenkoDetailInfoGetRes>
                        ) => {
                          let d = ""
                          if (context.item.点呼日) {
                            d = dayjs(context.item.点呼日).format("MM/DD")
                            return <>{d}</>
                          } else {
                            return <></>
                          }
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="実点呼日"
                      width={80}
                      multiLine={true}
                      header="実点呼日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTenkoDetailInfoGetRes>
                        ) => {
                          let d = ""
                          if (context.item.実点呼日) {
                            d = dayjs(context.item.実点呼日).format("MM/DD")
                            return <>{d}</>
                          } else {
                            return <></>
                          }
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="点呼時刻"
                      width={85}
                      multiLine={true}
                      header="点呼時刻">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTenkoDetailInfoGetRes>
                        ) => {
                          let t = ""
                          if (context.item.点呼時刻) {
                            t = dayjs(
                              dayjs(context.item.点呼時刻).add(
                                parseInt(context.item.点呼時刻),
                                "ms"
                              )
                            ).format("HH:mm")
                            return <>{t}</>
                          } else {
                            return <></>
                          }
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="点呼執行者氏名"
                      width={150}
                      header="点呼執行者"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="点呼記録方法区分名称1"
                      width={85}
                      header="記録方法"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="点呼アラート区分名称1"
                      width={120}
                      cssClass="text-danger fw-bold"
                      header="アラート"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="点呼区分名称1"
                      width={85}
                      header="点呼方法"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="点呼回数"
                      width={85}
                      header="点呼回数">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTenkoDetailInfoGetRes>
                        ) =>
                          context.item?.点呼回数 ? (
                            <>{context.item.点呼回数}回目</>
                          ) : (
                            <></>
                          )
                        }
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="点呼場所名"
                      width={120}
                      header="点呼場所"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="日常点検フラグ"
                      align="center"
                      width={85}
                      header="日常点検">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTenkoDetailInfoGetRes>
                        ) => {
                          return context.item.日常点検フラグ === 1 ? (
                            <>○</>
                          ) : context.item.日常点検フラグ === 0 ? (
                            <>×</>
                          ) : (
                            <></>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="免許証フラグ"
                      align="center"
                      width={85}
                      header="免許証">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTenkoDetailInfoGetRes>
                        ) => {
                          return context.item.免許証フラグ === 1 ? (
                            <>○</>
                          ) : context.item.免許証フラグ === 0 ? (
                            <>×</>
                          ) : (
                            <></>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="酒気帯フラグ"
                      align="center"
                      width={85}
                      header="酒気帯">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTenkoDetailInfoGetRes>
                        ) => {
                          return context.item.酒気帯フラグ === 0 ? (
                            <>○</>
                          ) : context.item.酒気帯フラグ === 1 ? (
                            <>×</>
                          ) : (
                            <></>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="AL検知器使用フラグ"
                      align="center"
                      width={85}
                      header="検知器使用">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTenkoDetailInfoGetRes>
                        ) => {
                          return context.item.AL検知器使用フラグ === 1 ? (
                            <>○</>
                          ) : context.item.AL検知器使用フラグ === 0 ? (
                            <>×</>
                          ) : (
                            <></>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="AL測定値"
                      width={85}
                      header="測定結果"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="疲労疾病フラグ"
                      align="center"
                      width={85}
                      header="疲労疾病">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTenkoDetailInfoGetRes>
                        ) => {
                          return context.item.疲労疾病フラグ === 0 ? (
                            <>○</>
                          ) : context.item.疲労疾病フラグ === 1 ? (
                            <>×</>
                          ) : (
                            <></>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="睡眠不足フラグ"
                      align="center"
                      width={85}
                      header="睡眠不足">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTenkoDetailInfoGetRes>
                        ) => {
                          return context.item.睡眠不足フラグ === 0 ? (
                            <>○</>
                          ) : context.item.睡眠不足フラグ === 1 ? (
                            <>×</>
                          ) : (
                            <></>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="指示事項1区分名称1"
                      width={200}
                      header="指示事項"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="報告事項テキスト"
                      width={200}
                      header="その他指示"></wjrGrid.FlexGridColumn>
                  </FlexGridOuter>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </FunctionContext.Provider>
      </Container>
    </>
  )
}
export default TenkoResultList
